import { PopupViewState } from 'booker/utils'
import { apiCall } from '../utils/api'

type PopupViewResponse = {
   shown: boolean
   expires_at: string | null
}

type Props = {
   popupId: number
   visitorToken: string
   account?: string
   locale?: string
}

export async function fetchPopupShownFromBackend({ popupId, visitorToken, account, locale }: Props): Promise<PopupViewState> {
   try {
      const result = await apiCall({
         method: 'GET',
         url: `${process.env.REACT_APP_PUBLIC_HOTELS_API}/popups/${popupId}/views`,
         params: { visitor_token: visitorToken },
      },
         account,
         locale)
      const { shown, expires_at } = result.data as PopupViewResponse
      return { shown, expiresAt: expires_at }
   } catch {
      return { shown: false, expiresAt: null }
   }
}

export async function recordPopupShownToBackend(
   { popupId, visitorToken, expiredAt, account, locale }: {
      popupId: number
      visitorToken: string
      expiredAt: Date | null
      account?: string
      locale?: string
   }
): Promise<void> {
   try {
      await apiCall({
         method: 'POST',
         url: `${process.env.REACT_APP_PUBLIC_HOTELS_API}/popups/views`,
         data: {
            popup_id: popupId,
            visitor_token: visitorToken,
            expires_at: expiredAt?.toISOString() ?? null,
         },
      },
         account,
         locale)
   } catch {
      // fire-and-forget
   }
}
